<template>
    <div class="container">
        <div v-if="loadFiles" class="vld-parent" style="height: 300px;">
            <Loading
                    :active.sync="loadFiles"
                    :is-full-page="fullPage"
                    :height="128"
                    :color="'#000000'"
            ></Loading>
        </div>
        <div v-if="!loadFiles" class="mt-20">
            <div v-if="files.length === 0" class="text-center"></div>
            <div v-else>
                <template v-if="files.filter(f => f.filetype === 'REPORTE-FILE')">
                    <h3 class="text-center">Reporte de la Consultas Públicas</h3>
                    <div class="d-flex justify-content-center flex-wrap my-4">
                        <div v-for="file in files.filter(f=>f.id !== imagen_id)" :key="file.id" class="d-flex justify-content-center">
                            <div class="pa-10" v-if="file.filetype === 'REPORTE-FILE'">
                                <div class="">
                                    <button
                                            class="py-2 pr-3 pl-3 pr-md-20 pl-md-20 text-white text-capitalize vld-parent d-flex align-items-center button-width"
                                            @click="downloadFile(file.id)"
                                            :class="mode==='dark'?'btn-lg btn-outline-grey':'btn-lg btn-primary'"
                                    >
                                        <i v-if="file.filetype == 'PRIMARY-IMAGE'" class="far fa-file-image fa-1x pr-sm-3 mr-2"></i>
                                        <i v-else-if="file.filetype == 'DOCUMENT'" class="far fa-file-alt fa-1x pr-sm-3 mr-2"></i>
                                        <i v-else-if="file.filetype == 'IMAGE'" class="far fa-file-image fa-1x pr-sm-3 mr-2"></i>
                                        <i v-else-if="file.filetype == 'AUDIO'" class="far fa-file-audio fa-1x pr-sm-3 mr-2"></i>
                                        <span class="align-self-center button-text-wrap">{{ file.original_name }}</span>
                                        <loading
                                                :active.sync="loadBtnDownloads.find(loadBtnDownload => loadBtnDownload.file_id === file.id).value"
                                                :is-full-page="fullPage"
                                                :height="24"
                                                :color="color"
                                        ></loading>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from '../../backend/axios';
    import Loading from 'vue-loading-overlay';
    export default {
        name: 'PublicConsultation',
        components: {
            Loading
        },
        props: {
            public_consultation_id: Number,
            //imagen_id: Number
        },
        data() {
            return {
                files: [],
                loadBtnDownloads: [],
                loadFiles: true,
            }
        },
        mounted() {
            this.getFiles();
        },
        methods: {
            getFiles() {
                axios.get('/consultations/' + this.public_consultation_id + '/files')
                .then(res=>{
                    this.files = res.data;
                    this.files.forEach(file=>{
                        this.loadBtnDownloads.push({
                            file_id: file.id,
                            value: false
                        });
                    });
                })
                .finally(()=>{
                    this.loadFiles = false
                });
            },
            downloadFile(fileId) {
                let file = this.files.find(file => file.id === fileId);
                let loadBtnDownload = this.loadBtnDownloads.find(loadBtnDownload => loadBtnDownload.file_id === fileId);
                loadBtnDownload.value = true;
                console.log(file.id);
                axios({
                    method: 'get',
                    url: '/storage/consultations/' + this.public_consultation_id + '/' + file.stored_name + '.' + file.extension,
                    responseType: 'blob'
                })
                .then(res => {
                    let type = res.headers['content-type'];
                    let blob = new Blob([res.data], {type: type});
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = file.original_name + '.' + file.extension;
                    document.body.appendChild(link);
                    link.click();

                    this.$toastr(
                        'success',
                        this.$t('proyecto.componentes.archivos.mensajes.exito.descargado.generico.cuerpo'),
                        this.$t('proyecto.componentes.archivos.mensajes.exito.descargado.generico.titulo')
                    );
                    document.body.removeChild(link);
                })
                .catch(() => {
                    this.$toastr(
                        'error',
                        this.$t('proyecto.componentes.archivos.mensajes.fallido.descargado.generico.cuerpo'),
                        this.$t('proyecto.componentes.archivos.mensajes.fallido.descargado.generico.titulo')
                    );
                })
                .finally(() => {
                    loadBtnDownload.value = false;
                });
            }
        },
    }
</script>